import { render, staticRenderFns } from "./TableComponentServerSingleWithFilter.vue?vue&type=template&id=dce9058a&scoped=true&"
import script from "./TableComponentServerSingleWithFilter.vue?vue&type=script&lang=js&"
export * from "./TableComponentServerSingleWithFilter.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentServerSingleWithFilter.vue?vue&type=style&index=0&id=dce9058a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce9058a",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QBtn,QBadge,QSplitter,QTable,QTr,QIcon,QSpace,QInnerLoading,QSpinnerGears,QDialog} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QBtn,QBadge,QSplitter,QTable,QTr,QIcon,QSpace,QInnerLoading,QSpinnerGears,QDialog}, component.options.components || {})
